export default __webpack_public_path__ + "static/media/banner_mask.34d038c8.png";